import 'core-js/features/promise';
import 'url-polyfill';

export function setUp() {
    const fillFetch = () => {
        if (!global.fetch) {
            return import('whatwg-fetch');
        }

        return Promise.resolve();
    };

    const fillCoreJs = () => {
        // This is not an exhaustive list of ES functions used, and we should look to replace this with a more concrete condition
        if (
            !(
                'startsWith' in String.prototype &&
                'endsWith' in String.prototype &&
                'includes' in Array.prototype &&
                'assign' in Object &&
                'keys' in Object
            )
        ) {
            return import('core-js/stable');
        }

        return Promise.resolve();
    };

    if (!(Object.setPrototypeOf || {}.__proto__)) {
        const nativeGetPrototypeOf = Object.getPrototypeOf;

        Object.getPrototypeOf = function (object) {
            if (object.__proto__) {
                return object.__proto__;
            } else {
                return nativeGetPrototypeOf.call(Object, object);
            }
        };
    }

    return Promise.all([fillFetch(), fillCoreJs()]);
}
